import { BasicInitLoggerCommand } from "@goodgamestudios/core";
import { ConsoleConnector } from "@goodgamestudios/core";
import { ILogMeisterConnector } from "@goodgamestudios/core";
import { LogMeister } from "@goodgamestudios/core";
import { LoggingConstants } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

export class Poker2InitLoggerCommand extends BasicInitLoggerCommand {
    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }

    protected configureLogger(): void {
        var console: ILogMeisterConnector = new ConsoleConnector();

        console.format = LoggingConstants.FORMAT_DEFAULT_TRACE;

        // Default logger target
        LogMeister.addLogger(console);
    }
}

classImplementsInterfaces(Poker2InitLoggerCommand, "ISimpleCommand");
